import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';

import { Form } from '@/modules/recognition/presentation/components/Form';
import { BasicInfoViewModel } from '@/modules/recognition/presentation/screens/AccountManagement/BasicInfo.vm';
import { Button } from '@/shared/presentation/components/ui/Button';
import { Input } from '@/shared/presentation/components/ui/Input';
import { Page } from '@/shared/presentation/components/ui/Page';
import { PhoneInput } from '@/shared/presentation/components/ui/PhoneInput';
import { Space } from '@/shared/presentation/components/ui/Space';

export const BasicInfoScreen = observer(() => {
  const vm = useViewModel(BasicInfoViewModel);

  return (
    <Page
      title="Dados pessoais"
      subtitle="Visualize e edite seus dados pessoais"
      hasError={vm.hasError}
      isLoading={vm.isLoading}
      errorMessage="Erro ao carregar as informações"
    >
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          vm.update();
        }}
      >
        <Input
          placeholder="Nome completo"
          label="Nome"
          name="name"
          value={vm.form.values.name}
          errorMessage={vm.form.errors.name && vm.form.errors.name[0]}
          onChange={(value) => vm.form.setValue('name', value)}
          onBlur={() => vm.form.validateField('name')}
        />

        <Space height={16} />

        <Input
          disabled
          placeholder="E-mail"
          label="E-mail"
          name="email"
          value={vm.form.values.email}
          errorMessage={vm.form.errors.email && vm.form.errors.email[0]}
          onChange={(value) => vm.form.setValue('email', value)}
          onBlur={() => vm.form.validateField('email')}
        />

        <Space height={16} />

        <PhoneInput
          placeholder="Telefone"
          label="Telefone"
          name="phone"
          value={vm.form.values.phone}
          errorMessage={vm.form.errors.phone && vm.form.errors.phone[0]}
          onChange={(value) => vm.form.setValue('phone', value)}
          onBlur={() => vm.form.validateField('phone')}
        />

        <Space height={32} />

        <Button
          type="submit"
          disabled={!vm.form.isValid || vm.isSubmitting}
          variant="primary"
          loading={vm.isSubmitting}
        >
          Salvar
        </Button>
      </Form>
    </Page>
  );
});
